<template>
  <div class="d-flex justify-space-between userblock-container items-center pt-2">
    <div class="search-wrapper">
      <HostingSearch />
    </div>
    <div class="d-flex flex-row gap-4">
      <div class="pr-8">
        <v-btn icon @click="$router.push('/support')">
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn>
        <notifications />
      </div>
      <div>
        <v-menu
          bottom
          offset-y
          left
          attach="#user-menu"
          content-class="userblock-dropdown"
          disable-keys
          nudge-top="-10"
          nudge-right="0"
          transition="slide-y-transition"
          min-width="225"
          :close-on-content-click="false"
          v-model="menu"
        >
          <template v-slot:activator="{ on }">
            <div v-on="on" @click="requestToken">
            <span class="display-ib pr-2 v-align--bottom text-right cursor-pointer">
              <span class="fs-14 d-block" v-html="userName" />
              <span class="fs-12 fw-light d-block">
                {{ SessionProfile.email }}
              </span>
            </span>
              <v-avatar size="42" class="cursor-pointer">
                <img :src="SessionProfile.gravatar"  alt="avatar"/>
              </v-avatar>
              <v-btn icon aria-label="Profile menu" :ripple="false" plain>
                <v-icon class="cursor-pointer">mdi-chevron-down</v-icon>
              </v-btn>
            </div>
          </template>
          <div class="dropdown-content">
            <div class="dropdown-top white--text text-right">
            <span class="white--text fs-14 font-weight-medium d-block">
              {{ SessionProfile.firstname }} {{ SessionProfile.lastname }}
            </span>
              <span class="d-block fs-12 fw-light">{{ SessionProfile.email }}</span>
              <span class="d-block fs-14 fw-light">
              Customer ID:
              <b class="font-weight-medium"> {{ SessionProfile.accountId }}</b>
            </span>
              <span class="d-block fs-14 fw-light">
              Support PIN:
              <v-progress-circular v-if="loadingSupportToken"
                                   indeterminate
                                   class="mx-2"
                                   size="14"
                                   width="2"
                                   color="white"
              />
              <template v-else>
                <b class="font-weight-medium"> {{ supportToken }}</b>
              </template>
              <gg-btn v-show="!supportToken && !loadingSupportToken"  color="white" text @click.stop="requestToken">
                Request
              </gg-btn>
            </span>
              <div class="text-right" aria-hidden="true">
                <v-switch v-model="$vuetify.theme.dark"
                          tabindex="-1"
                          class="theme-switcher mt-1 d-inline-block"
                          color="white"
                          hide-details
                          label="Dark Mode"
                          @change="switchTheme(false)"
                />
              </div>
            </div>
            <div class="v-list dropdown-list user-menu">
              <router-link :to="{ name: 'profile_info' }"
                           class="user-menu-item pa-4 ma-1 d-flex"
                           @click.native="closeMenu"
                           tabindex="0">
                <v-icon small class="mr-3 primary--text">mdi-account</v-icon>
                <span :class="{ 'black--text': !isDarkTheme }">My Profile</span>
              </router-link>
              <router-link :to="{ name: 'billing' }"
                           class="user-menu-item user-menu-item pa-4 ma-1 d-flex"
                           @click.native="closeMenu"
                           tabindex="0">
                <v-icon small class="mr-3 primary--text">mdi-currency-usd</v-icon>
                <span :class="{ 'black--text': !isDarkTheme }">Billing</span>
              </router-link>
              <a @click.stop="logOut"
                 href="#"
                 class="user-menu-item user-menu-item pa-4 ma-1 d-flex"
                 tabindex="0">
                <v-icon small class="mr-3 primary--text">mdi-power</v-icon>
                <span :class="{ 'black--text': !isDarkTheme }">Logout</span>
              </a>
            </div>
          </div>
        </v-menu>
        <div id="user-menu"></div>
      </div>
      <div class="navbar-switcher">
        <gg-btn
          class="pl-0 ml-0 d-flex d-lg-none"
          icon
          @click.stop="drawer = !drawer"
        >
          <v-icon>mdi-menu</v-icon>
        </gg-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import Notifications from 'Components/General/Header/Notifications/Notifications'
import HostingSearch from 'Components/Services/HostingSearch'

export default {
  components: {
    Notifications,
    HostingSearch,
  },
  data () {
    return {
      menu: false,
    }
  },
  computed: {
    ...mapGetters(['SessionProfile', 'supportToken', 'navDrawer', 'loadingSupportToken']),
    drawer: {
      get () {
        return this.navDrawer
      },
      set (val) {
        this.SET_NAV_DRAWER(val)
      }
    },
    userName () {
      const id = this.SessionProfile.accountId
      const fName = this.SessionProfile.firstname
      const lName = this.SessionProfile.lastname

      return `ID#${id} - <b>${fName} ${lName}</b>`
    },
    isDarkTheme () {
      return this.$vuetify.theme.dark
    }
  },
  methods: {
    ...mapActions(['attemptLogout', 'getSupportToken', 'reportError', 'reportLogout']),
    ...mapMutations(['SET_NAV_DRAWER']),
    switchTheme (changeModel) {
      if (changeModel === true) {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      }
      const theme = this.$vuetify.theme.dark ? 'dark' : 'light'
      localStorage.setItem('theme', theme)
    },
    async requestToken () {
      this.menu = true
      if (this.supportToken) return
      // load support pin
      try {
        await this.getSupportToken()
      } catch (e) {
        this.reportError(e)
      }
    },
    closeMenu () {
      this.menu = false
    },
    async logOut () {
      try {
        await this.attemptLogout()
        this.reportLogout('You have successfully logged out.')
      } catch (e) {
        this.reportError(e)
      }
    }
  },
}
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}

.max-width-80 {
  max-width: 80px;
}

.userblock-container {
  justify-content: end;

  @media screen and (max-width: 760px) {
    flex-direction: column-reverse;
    gap: 1.5rem;
  }
}

.search-wrapper {
  width: 100%;
  padding: 0 1rem;

  @media screen and (min-width: 761px) {
    width: 40%;
    padding: 0;
  }
}

.user-menu-item {
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.11);
  font-size: 14px;
  &:focus-visible {
    outline: dashed 1px #464D69;
  }
}
</style>
